import React from "react";
import { useState, useEffect } from "react";
import "./commonComponent.css";

export const TabList = (props) => {
  let { tabListItems, id } = props;

  let [currentItem, setCurrentItem] = useState(null);

  useEffect(() => {
    setCurrentItem(tabListItems[0]);
  }, [id])

  function updateCurrentItem (idx) {
    let targetItem = tabListItems.filter(item => item.key == idx)[0];
    if (targetItem.key != currentItem.key){
      setCurrentItem(targetItem)
    }
  }

  return (
    <div className="tab_list_wrapper">
      <div className="tab_list_control">
        {currentItem && tabListItems.map((item, idx) => (
          <div
            className={`tab_list_control_item ${currentItem.key == idx ? "ctrl_item_active" : ""}`}
            key={idx}
            onClick={() => updateCurrentItem(idx)}
          >
            {item.name}
          </div>
        ))}
      </div>
      <div className="tab_list_display">{currentItem && currentItem.content}</div>
    </div>
  );
};

